import React from 'react';
import PropTypes from 'prop-types';
import { PrimaryButton } from 'DesignSystem/Buttons';

const UseSignatureButton = ({ type, useSignatureOnClick }) => (
  <PrimaryButton
    className="signature-preview-button use-btn"
    onClick={(e) => { useSignatureOnClick(type, e); }}
    size="xs"
    variation="normal"
  >
    Use Signature
  </PrimaryButton>
);

UseSignatureButton.propTypes = {
  type: PropTypes.string.isRequired,
  useSignatureOnClick: PropTypes.func.isRequired,
};

export default UseSignatureButton;



// WEBPACK FOOTER //
// ./src-react/SignatureManager/components/UseSignatureButton.jsx